import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  records: [],
  messages: {}, // keyed by conversationId
  supervisedConversations: [],
  supervisedUser: null,
  uiFlags: {
    isFetchingConversations: false,
    isCreatingConversation: false,
    isFetchingMessages: false,
    isSendingMessage: false,
    isFetchingSupervised: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
